import { client } from '../client'

export async function telegram() {
  await client.commands.openExternalLink({
    url: 'https://t.me/hamster_bombaster_bot/start',
  })
}
